/**
 * Experiment constants for A/B testing
 */

// Available experiment topics
export const EXPERIMENT_TOPICS = {
  BAR_TITLE: 'bar_title',
} as const;

// Default experiments to include in API requests
export const DEFAULT_EXPERIMENTS = [EXPERIMENT_TOPICS.BAR_TITLE];

// Type for experiment topics
export type ExperimentTopic = (typeof EXPERIMENT_TOPICS)[keyof typeof EXPERIMENT_TOPICS];
